export enum AuthResponseErrors {
  USER_DISABLED = 'User is disabled.',
}
